<template>
  <div @keyup.enter="enterSearch">
    <el-form :model="form" ref="form" class="table-search-bar" inline label-width="70px">
      <el-form-item label="客户名称" prop="customerName">
        <el-input v-model="form.customerName" clearable placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item label="客户类型" prop="status">
        <el-select v-model="form.status">
          <el-option v-for="item in statusOptions"
            :key="item.label"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="变更时间" prop="effectiveTime">
              <el-date-picker
                v-model="form.effectiveTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                >
              </el-date-picker>
            </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <!-- <el-button type="primary" @click="handleAdd">新增</el-button> -->
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      tooltip-effect="light"
      style="width: 100%">
      <el-table-column
        prop="customerName"
        label="客户名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orgName"
        label="经营组织"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="statusName"
        label="客户状态"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="updatePerson"
        label="操作人"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="变更时间"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        :show-overflow-tooltip="true">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20 ,50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <el-row class="export-row" type="flex" justify="end" v-permission="'0178801'">
      <el-col :span="4">
        每页
        <el-select class="width100" v-model="exportForm.pageSize" @change="handleExportSizeChange">
          <el-option v-for="item in sizeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        条
      </el-col>
      <el-col :span="4">
        第
        <el-select class="width100" v-model="exportForm.pageNo">
          <el-option v-for="item in pageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        页
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="handleExport">导出为CSV文件</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StatisticalReportSalePlanCustom',
  data () {
    return {
      form: {
        status: '',
        customerName: '',
        effectiveTime: []
      },
      exportForm: {
        pageSize: 1000,
        pageNo: 1
      },
      sizeOptions: [
        {
          label: '1000',
          value: 1000
        },
        {
          label: '5000',
          value: 5000
        },
        {
          label: '10000',
          value: 10000
        },
        {
          label: '20000',
          value: 20000
        }
      ],
      statusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '正常',
          value: '0'
        },
        {
          label: '锁定',
          value: '1'
        },
        {
          label: '冻结',
          value: '3'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      list: 'getStatisticalReportCustomerStatusChangeList',
      listState: 'getStatisticalReportCustomerStatusChangeListState'
    }),
    pageOptions () {
      const total = this.listState.total
      const size = this.exportForm.pageSize
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getStatisticalReportCustomerStatusChangeList', 'exportStatisticalReportCustomerStatusChangeList']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSizeChange (val) {
      this.getStatisticalReportCustomerStatusChangeList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getStatisticalReportCustomerStatusChangeList({ pageNo: val })
    },
    handleSearch () {
      const params = {
        ...this.form,
        startTime: this.form.effectiveTime && this.form.effectiveTime[0],
        endTime: this.form.effectiveTime && this.form.effectiveTime[1],
        pageNo: 1
      }
      this.getStatisticalReportCustomerStatusChangeList(params)
    },
    handleAdd () {
      // 打开新增页面
    },
    handleReset () {
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    handleCheck (index, row) {
      // 打开查看界面
    },
    handleEdit (index, row) {
      // 打开编辑界面
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.exportForm.pageNo = 1
    },
    // 导出
    handleExport () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const formParams = {
          ...this.form,
          startTime: this.form.effectiveTime && this.form.effectiveTime[0],
          endTime: this.form.effectiveTime && this.form.effectiveTime[1]
        }
        this.exportStatisticalReportCustomerStatusChangeList({ ...formParams, ...this.exportForm }).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '客户状态变更报表.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.export-row {
  margin-top: 10px;
}
.width100{
  width: 100px;
}
</style>
